import brand from './tla-housing-europe.json';

export default brand;
